// src/pages/customer/CustomerDashboard.js
import { useEffect, useState, useContext } from "react";
import api from "../api/axios";
import { AuthContext } from "../context/AuthContext";

import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Divider,
} from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HomeIcon from "@mui/icons-material/Home";
import HistoryIcon from "@mui/icons-material/History";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ReplayIcon from "@mui/icons-material/Replay";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";

const CustomerDashboard = () => {

  const { user } = useContext(AuthContext);
  // const [orders, setOrders] = useState([]);
  const [buyAgainProducts, setBuyAgainProducts] = useState([]);

  const [totalOrders, setTotalOrders] = useState(0);
const [recentOrders, setRecentOrders] = useState([]);
// const [buyAgainProducts, setBuyAgainProducts] = useState([]);

  const navigate = useNavigate();
  const { wishlist } = useWishlist();

  // useEffect(() => {
  //   if (!user?.username) return;

  //   api
  //     .get(`/orders/customer/${user.username}`)
  //     .then((res) => {
  //       const orderList = res.data.orders || [];
  //       setOrders(orderList);

  //       // Extract unique products from delivered orders for "Buy Again"
  //       const productMap = new Map();
  //       orderList.forEach(order => {
  //         if (order.tracking?.at(-1)?.label === "Delivered" && order.items) {
  //           order.items.forEach(item => {
  //             if (!productMap.has(item.productId)) {
  //               productMap.set(item.productId, item);
  //             }
  //           });
  //         }
  //       });
  //       setBuyAgainProducts(Array.from(productMap.values()).slice(0, 4));
  //     })
  //     .catch(() => setOrders([]));
  // }, [user?.username]);

  useEffect(() => {
  if (!user?.username) return;

  api
    .get(`/orders/customer/${user.username}/dashboard`)
    .then((res) => {
      setTotalOrders(res.data.totalOrders);
      setRecentOrders(res.data.recentOrders);
      setBuyAgainProducts(res.data.buyAgainProducts);
    })
    .catch(() => {
      setTotalOrders(0);
      setRecentOrders([]);
      setBuyAgainProducts([]);
    });

}, [user?.username]);

// const recentOrders = orders.slice(0, 3);

  return (
    <Box sx={{ p: 4, background: "#f5f5f5", minHeight: "100vh" }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
        Customer Dashboard
      </Typography>

      {/* TOP QUICK INFO */}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Card
                sx={{
                    borderRadius: 3,
                    cursor: "pointer",
                    transition: "0.2s",
                    "&:hover": { boxShadow: 6, transform: "translateY(-2px)" },
                  }}
                onClick={() => navigate("/customer/orders")}
              >
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <ShoppingBagIcon sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {totalOrders} Orders
                </Typography>
                <Typography color="textSecondary">Total Orders</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <LocalShippingIcon sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  3 In Transit
                </Typography>
                <Typography color="textSecondary">Orders on the way</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card
          sx={{
          borderRadius: 3,
          cursor: "pointer",
          transition: "0.2s",
          "&:hover": { boxShadow: 6, transform: "translateY(-2px)" },
        }}
         onClick={() => navigate("/wishlist")}
          >
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <FavoriteIcon sx={{ fontSize: 40, color: "red" }} />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {wishlist.length} Wishlisted
                </Typography>
                <Typography color="textSecondary">Saved for later</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              borderRadius: 3,
              cursor: buyAgainProducts.length > 0 ? "pointer" : "default",
              transition: "0.2s",
              "&:hover": buyAgainProducts.length > 0 ? { boxShadow: 6, transform: "translateY(-2px)" } : {},
            }}
            onClick={() => buyAgainProducts.length > 0 && navigate(`/product/${buyAgainProducts[0].productId}`)}
          >
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <ReplayIcon sx={{ fontSize: 40, color: "#ff9900" }} />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {buyAgainProducts.length} Buy Again
                </Typography>
                <Typography color="textSecondary">Reorder items</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* RECENT ORDERS */}
      <Box sx={{ mt: 5 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          Recent Orders
        </Typography>

        <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
          <CardContent>
            {recentOrders.map((order, index) => {
              const firstItem = order.items?.[0];
              const extraCount = (order.items?.length || 1) - 1;

              return (
  <Box key={order._id}>
    <Box
      sx={{
        display: "flex",
        py: 2,
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      {/* Product Image */}
      <Box
        sx={{
          flexShrink: 0,
          width: 80,
          height: 80,
          backgroundColor: "#f5f5f5",
          borderRadius: 1,
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #e0e0e0",
        }}
      >
        {firstItem?.imageUrl ? (
          <img
            src={firstItem.imageUrl}
            alt={firstItem.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <Typography variant="caption" color="textSecondary">
            No Image
          </Typography>
        )}
      </Box>

      {/* Order Info */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 600 }}>
          Order #{order._id.slice(-6)}
        </Typography>
        {firstItem && (
          <Typography
            sx={{ fontSize: 14, color: "text.secondary", mb: 0.5 }}
          >
            {firstItem.title}
            {extraCount > 0 && (
              <Typography component="span" sx={{ fontSize: 13, color: "#007185", ml: 0.5 }}>
                +{extraCount} more item{extraCount > 1 ? "s" : ""}
              </Typography>
            )}
          </Typography>
        )}
        <Typography color="textSecondary" sx={{ fontSize: 13 }}>
          {new Date(order.createdAt).toLocaleDateString()}
        </Typography>
      </Box>

      <Box sx={{ textAlign: "right", flexShrink: 0 }}>
        <Typography sx={{ fontWeight: 600 }}>
          ₹{Number(order.total).toLocaleString("en-IN")}
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            color:
              order.tracking?.at(-1)?.label === "Delivered"
                ? "green"
                : "#ff9900",
          }}
        >
          {order.tracking?.at(-1)?.label}
        </Typography>

        <Button
          size="small"
          sx={{ textTransform: "none", mt: 1 }}
          onClick={() =>
            navigate(`/customer/orders/${order._id}`)
          }
        >
          View Order →
        </Button>
      </Box>
    </Box>

    {index < recentOrders.length - 1 && <Divider />}
  </Box>
              );
            })}

          </CardContent>
        </Card>
      </Box>

      {/* ADDRESSES, BROWSING HISTORY & HELP */}
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              p: 3,
              borderRadius: 3,
              boxShadow: 2,
              cursor: "pointer",
              transition: "0.2s",
              "&:hover": { boxShadow: 6, transform: "translateY(-2px)" },
            }}
            onClick={() => navigate("/register/customer")}
          >
            <HomeIcon sx={{ fontSize: 50, color: "#666" }} />
            <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
              Your Addresses
            </Typography>
            <Typography color="textSecondary" sx={{ mb: 2 }}>
              Manage your delivery addresses
            </Typography>

            <Button
              variant="contained"
              sx={{
                background: "#494948",
                textTransform: "none",
                borderRadius: 2,
              }}
            >
              Manage Addresses
            </Button>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              p: 3,
              borderRadius: 3,
              boxShadow: 2,
              cursor: "pointer",
              transition: "0.2s",
              "&:hover": { boxShadow: 6, transform: "translateY(-2px)" },
            }}
            onClick={() => navigate("/browse-history")}
          >
            <HistoryIcon sx={{ fontSize: 50, color: "#666" }} />
            <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
              Browsing History
            </Typography>
            <Typography color="textSecondary" sx={{ mb: 2 }}>
              View products you've recently viewed
            </Typography>

            <Button
              variant="contained"
              sx={{
                background: "#494948",
                textTransform: "none",
                borderRadius: 2,
              }}
            >
              View History
            </Button>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2 }}>
            <HelpOutlineIcon sx={{ fontSize: 50, color: "#666" }} />
            <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
              Help & Customer Service
            </Typography>
            <Typography color="textSecondary" sx={{ mb: 2 }}>
              Returns, help topics, and contact us
            </Typography>

            <Button
              variant="contained"
              sx={{
                background: "#494948",
                textTransform: "none",
                borderRadius: 2,
              }}
              onClick={() => navigate("/customer/orders")}
            >
              Visit Help Hub
            </Button>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerDashboard;
